<template>
  <div class="container">
    <div class="onsite mb-5">
      <h3>Online Training</h3>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="reading">
          <p>
            Our online training programs are flexible, allowing learners to
            study at their own pace and from anywhere in the world, making it
            convenient for busy individuals to upgrade their skills.
          </p>
          <p>
            We strive to create a positive and inclusive learning environment
            where learners can collaborate, network, and learn from each other,
            creating a community of like-minded individuals who are passionate
            about digital skills.
          </p>
          <p>
            Our instructors are experienced professionals in their respective
            fields, bringing their practical knowledge and industry insights
            into the training programs to provide learners with valuable
            guidance and mentorship.
          </p>
          <p>
            Join us at Fhenix Africa and unlock your potential in the digital
            world with our comprehensive online training programs. Upgrade your
            skills, boost your career prospects, and thrive in the digital
            economy!
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="oncheck">
          <img
            src="../assets/Images/onlinetraining.png"
            alt=""
            class="img-fluid"
          />
        </div>
      </div>
      <div class="available">
        <div class="tracks">
          <h6>Our Popular Courses</h6>
          <p>
           Here are some of the courses we offer
          </p>
        </div>
        <div class="row my-5">
          <div
            class="col-lg-4 col-md-6 ram"
            v-for="currentCourse in currentCourses"
            :key="currentCourse"
          >
            <div class="mycourse p-3 h-100">
              <small>{{ currentCourse.name }}</small>
              <p class="mb-5 mt-2">{{ currentCourse.paragraph }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import More from "@/components/More.vue";
let id = 0;
export default {
  data() {
    return {
      currentCourses: [
        {
          id: id++,
          name: "Android Development(Andriod/flutter)",
          paragraph:
            "Our Android development training covers a wide range of topics, including Java and Kotlin programming languages, UI/UX design, app architecture, database integration, networking, and more. Learners will also learn how to test, debug, and optimize their apps to ensure they meet industry standards and deliver a seamless user experience.",
        },
        {
          id: id++,
          name: "Frontend Web Development",
          paragraph:
            "Our expert instructors bring their extensive industry experience to provide comprehensive training in frontend web development, covering topics such as HTML, CSS, JavaScript, responsive design, and user experience (UX) design. Learners will gain hands-on experience through practical exercises, projects, and real-world examples, allowing them to apply their skills in building functional and visually appealing websites.",
        },
        {
          id: id++,
          name: "Backend Web Development",
          paragraph:
            "From building APIs and working with databases to server-side scripting and performance optimization, our Backend development training program equips learners with the skills needed to develop robust and scalable web applications.",
        },
        {
          id: id++,
          name: "UI/UX",
          paragraph:
            "Our UI/UX design course provides comprehensive training that covers the latest tools, techniques, and best practices in product design. Learners will gain a deep understanding of user-centered design principles, information architecture, wireframing, prototyping, usability testing, and more.",
        },
        {
          id: id++,
          name: "Digital Marketing",
          paragraph:
            "From understanding the fundamentals of digital marketing to mastering advanced concepts such as SEO, social media marketing, content marketing, email marketing, and more, our training program covers a wide range of topics to ensure learners are well-rounded in their digital marketing skills.",
        },
        {
          id: id++,
          name: "Product Management",
          paragraph:
            "Our training program is carefully curated to cover various aspects of product management, including product strategy, market research, product development, and product lifecycle management.",
        },
        {
          id: id++,
          name: "Computer Aided Design (CAD)",
          paragraph:
            "Our CAD training program covers CAD software such as AutoCAD, SolidWorks, Revit, and more. Learners will gain hands-on experience through practical exercises, projects, and real-world examples, allowing them to develop their CAD skills and apply them in real-time scenarios.",
        },
      ],
    };
  },
  components: {
    More,
  },
};
</script>

<style scoped>
/* for h tags  */
.onsite h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #335ca6;
}
.tracks h6 {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  color: #000000;
}
.our-service h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1f1f1f;
  margin-bottom: 3rem;
}
/* for p tags */
.reading p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
  margin-right: 55px;
}
.tracks p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}

.mycourse small {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #006ec3;
}
.mycourse p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}

.link {
  text-decoration: none;
  font-weight: bold;
}

/* for colors */
.mycourse:hover,
.mycourse:focus {
  background: #006ec312;
}
.mycourse {
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}
.ram {
  margin-bottom: 1.5rem;
}
.more-services {
  background: #ffffff;
  width: 100%;
  padding: 3.5rem 0;
}
/* for a tags */
.reacher {
  margin: 2.8rem 0;
}
/* for margins */
.available {
  margin-top: 5rem;
}
.reading {
  margin-top: 1.4rem;
}

img:hover {
  opacity: 0.6;
}

/* for responsiveness */
@media screen and (max-width: 768px) {
  .onsite h3 {
    text-align: center;
    margin-bottom: -40px;
  }

  .oncheck img {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 485px;
    width: 639px;
    margin-top: 25px;
  }
  .mycourse:hover {
    background: none;
  }
  .reading p {
    margin-right: 0px;
    text-align: center;
  }
  .reading {
    padding: 0px 33px;
  }
}

@media screen and (max-width: 425px) {
  .mycourse {
    margin: 0px 20px;
    text-align: center;
  }
  .mycourse p {
    padding: 0 34px;
    font-size: 23px;
  }
  .mycourse small {
    font-size: 26px;
  }

  .mycourse {
    background: none;
  }

  .reading {
    padding: 0px 63px;
  }

  .oncheck img {
    width: 537px;
  }
  .tracks {
    text-align: center;
  }
}
</style>